import window from 'ember-window-mock';

import { registerJsURL } from 'register-partners-js/constants/hosts';

export function redirectToRegisterJs(registrationId) {
  let url = new URL(registerJsURL);
  url.searchParams.set('skip', 'true');
  // Disambiguates which registration triggered `?skip=true`: a user can have several
  // (same email, different SIREN), and register-js otherwise has no way to tell which
  // one to redirect to (ZD-881).
  url.searchParams.set('partner_registration_id', registrationId);

  window.location.replace(url);
}
